import React from "react";
import { Link } from "react-router-dom";
import { Hero, Section } from "../components/Page/Page.js";
import ProjectMap from "../components/Page/ProjectMap.js";
import { projects } from "../data/content.js";

export default function MapScreen() {
  return (
    <>
      <Hero eyebrow="Impact / Map" title="Where our projects are" text="Every project, with its location and status." />
      <Section>
        {projects.map((p) => (
          <div key={p.slug} style={{ marginBottom: 56 }}>
            <h3 style={{ fontSize: 30, marginBottom: 6 }}><Link to={`/projects/${p.slug}`}>{p.title}</Link></h3>
            <p className="pg-post-meta" style={{ marginBottom: 14 }}>
              {p.status} / {p.facts.find(([k]) => k === "Location")?.[1] || "Location to be announced"}
            </p>
            {p.coords ? <ProjectMap coords={p.coords} title={p.title} /> : <p style={{ color: "var(--darkGreen06)" }}>Detailed location map coming soon.</p>}
          </div>
        ))}
      </Section>
    </>
  );
}
